function createElementFromHTML(htmlString) {
  var div = document.createElement("div");
  div.innerHTML = htmlString.trim();

  return div.childNodes;
}

const loadmore = async () => {
  const loadmoreButton = document.querySelector(".button-loadmore");
  const loop = document.querySelector("#loop");

  const form = new FormData();
  form.append("action", "loadmore");
  form.append("query", loadmore_params.posts);
  form.append("page", loadmore_params.current_page);
  const body = new URLSearchParams(form);

  const buttonLabel = loadmoreButton.innerHTML;
  loadmoreButton.innerHTML = "Loading ...";


    const response = await fetch(loadmore_params.ajaxurl, {
      // you can also use $.post here
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded" }),
      body: body
      // headers: {
      //   'Content-Type': 'application/json;charset=utf-8'
      // },
      // body: body
    });

    const result = await response.text();
   
    loadmoreButton.innerHTML = buttonLabel;

    if(response.status === 200){
      loop.insertAdjacentHTML("beforeend", result);
      loadmore_params.current_page++;
    }

    if (loadmore_params.current_page === +loadmore_params.max_page) {
      loadmoreButton.remove();
    }

    console.log('ee');
    window.initCatify && window.initCatify();

};

export const cleanLoadMore = () => {
  const loadmoreButton = document.querySelector(".button-loadmore");
  loadmoreButton && loadmoreButton.removeEventListener("click", loadmore);
};

export const initLoadMore = () => {
  const loadmoreButton = document.querySelector(".button-loadmore");
  loadmoreButton && loadmoreButton.addEventListener("click", loadmore);
};
